export default __webpack_public_path__ + "static/media/player-play.e60f735b.svg";